import React from 'react';
import { Constrain } from '@moda/om';
import { HelpCenter, AboutModa, HowToShop } from './SiteFooterLinks';
import { SiteFooterMailingList } from './SiteFooterMailingList';
import { SiteFooterBasement } from './SiteFooterBasement';
import './SiteFooterDesktop.scss';

export const SiteFooterDesktop = () => (
  <Constrain className="SiteFooterDesktop">
    <section className="SiteFooterDesktop__categories">
      <div className="SiteFooterDesktop__category">
        <h3>Shipping &amp; Returns</h3>
        <HelpCenter />
      </div>

      <div className="SiteFooterDesktop__category">
        <h3>About Moda</h3>
        <AboutModa />
      </div>

      <div className="SiteFooterDesktop__category">
        <h3>How to Shop</h3>
        <HowToShop />
      </div>

      <div className="SiteFooterDesktop__category">
        <h3>Join our list for daily style inspiration &amp; first access to global fashion.</h3>
        <SiteFooterMailingList />
      </div>
    </section>

    <SiteFooterBasement />
  </Constrain>
);
